import {getInputControlMeta} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useState} from 'react'
import {getLocale} from '../../../../../../../commons/selectors/environment'
import {useAppSelector} from '../../../../hooks/runtime'
import {Error} from '../../commons/error'
import {Label} from '../../commons/label'
import fs from '../../fields.scss'
import {classes} from './date.st.css'
import {DateProps} from './interfaces'
import DatePickerInput from './lazy-date-picker'

export const DateWithPicker = ({input: {value, onChange}, meta: {error, touched: formTouched}, control}: DateProps) => {
  const [touched, setTouched] = useState(false)
  const locale = useAppSelector(getLocale)
  const {isMobile: mobile} = useEnvironment()

  const {t} = useTranslation()

  const invalid = (touched || formTouched) && error
  const {mandatory, label} = getInputControlMeta(control)

  const handleChange = (date: any) => {
    onChange(
      date
        ? `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
            .getDate()
            .toString()
            .padStart(2, '0')}`
        : null,
    )
  }

  return (
    <div data-hook={invalid ? DH.FORM_INVALID_FIELD : ''} className={classNames(fs.field, classes.specificityFix)}>
      <Label classes={fs.customCaption} dataHook={DH.FORM_DATE_LABEL} required={mandatory} caption={label} />
      <DatePickerInput
        data-hook={DH.FORM_DATE_PICKER}
        className={classNames(classes.root, fs.withInput, {[classes.mobileRoot]: mobile})}
        inputWidth="100%"
        value={value ? new Date(value + 'T00:00:00') : undefined}
        placeholderText={t('viewer_selectDate')}
        showMonthDropdown
        showYearDropdown
        onChange={handleChange}
        onClose={() => setTouched(true)}
        hasError={Boolean(invalid)}
        locale={locale}
        // @ts-expect-error
        firstDayOfWeek={new Intl.Locale(locale)?.weekInfo?.firstDay === 7 ? 0 : 1}
      />
      <Error dataHook={DH.FORM_DATE_ERROR} error={invalid && t(error)} />
    </div>
  )
}
